export default __webpack_public_path__ + "static/media/metallic-carbonate.4b5beb26.jpg";